export const FIND_MAIL_TEMPLATE_REQUEST = 'FIND_MAIL_TEMPLATE_REQUEST';

export const findMailTemplateRequest = ( id ) => ({
    type: FIND_MAIL_TEMPLATE_REQUEST,
    payload: { id }
});
